import React from "react";

import { useDictionary } from "../../../../hooks";
import styles from "../ModelerToolbar.css";

export const UnknownTeamsError = ({ rulesWithUnknownTeams }) => {
	const dictionary = useDictionary("formDesigner.notifications");

	return (
		<React.Fragment>
			<p>
				{dictionary.unknownTeams}
			</p>
			<ul className={styles.unmatchedRulesList}>
				{rulesWithUnknownTeams.map(rule => {
					const ruleType = rule.ruleType.replaceAll("_", " ");

					return (
						<li key={`${rule.id}-${ruleType}-${rule.orderIndex}`}>
							<div>
								<span>{ruleType}</span>&nbsp; Rule Condition with Order&nbsp;
								<b>{rule.orderIndex}</b>&nbsp; references an unknown team.
							</div>
						</li>
					);
				})}
			</ul>
		</React.Fragment>
	);
};